const GradeIcon = () => {
  return (
    <svg
      width="11"
      height="12"
      viewBox="0 0 11 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.6665 7.5V8.5M5.6665 5.5V8.5M7.6665 3.5V8.5M3.5665 10.5H7.7665C8.60658 10.5 9.02662 10.5 9.34749 10.3365C9.62973 10.1927 9.8592 9.96323 10.003 9.68099C10.1665 9.36012 10.1665 8.94008 10.1665 8.1V3.9C10.1665 3.05992 10.1665 2.63988 10.003 2.31901C9.8592 2.03677 9.62973 1.8073 9.34749 1.66349C9.02662 1.5 8.60658 1.5 7.7665 1.5H3.5665C2.72643 1.5 2.30639 1.5 1.98552 1.66349C1.70328 1.8073 1.4738 2.03677 1.32999 2.31901C1.1665 2.63988 1.1665 3.05992 1.1665 3.9V8.1C1.1665 8.94008 1.1665 9.36012 1.32999 9.68099C1.4738 9.96323 1.70328 10.1927 1.98552 10.3365C2.30639 10.5 2.72643 10.5 3.5665 10.5Z"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default GradeIcon
